/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { ServizioMensaConfigurazioneDTO } from '../model/models';
import { ServizioMensaTariffaDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface GetServizioMensaConfigurazioneRequestParams {
    gestioneMenseServizioId: string;
}

export interface GetServizioMensaTariffaRequestParams {
    gestioneMenseServizioId: string;
}


export interface ServizioMensaConfigurazioneServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Configurazione del servizio mensa.
     * Ritorna i campi-config del servizio risolto dall\&#39;header Gestione-Mense-Servizio-Id (gestione_manuale, orario annullamento pasto, tipo pagamento, stato ricarica manuale, soglie promemoria/sospensione, email assistenza, mappa pasti-scuola) + servizio_id e date servizio. Audience servizio piena (OP_SCUOLA/OP_CENTRO_COTTURA/OP_COMUNE/ADMIN/SUPERADMIN). NON espone anno_di_riferimento (servizio multi-anno) né sincronizzazioni_esterne (GP dismessa).
     * @endpoint get /api/v1/servizi/mensa/configurazione
* @param requestParameters
     */
    getServizioMensaConfigurazione(requestParameters: GetServizioMensaConfigurazioneRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaConfigurazioneDTO>;

    /**
     * Tariffa del servizio mensa (read-only).
     * Ritorna la configurazione tariffaria (TariffaMensa 1:1) del servizio risolto dall\&#39;header Gestione-Mense-Servizio-Id: numero pasti per contributo, esenzione non autosufficiente, regole (ordine/contributo/condizioni) read-only senza handle di editing. Audience backoffice stretta (OP_COMUNE/ADMIN/SUPERADMIN): la tariffa è dato sensibile di calcolo, gli operatori-servizio puri (OP_SCUOLA/OP_CENTRO_COTTURA) ricevono 403.
     * @endpoint get /api/v1/servizi/mensa/tariffa
* @param requestParameters
     */
    getServizioMensaTariffa(requestParameters: GetServizioMensaTariffaRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaTariffaDTO>;

}
